import { MessageCircle, Palette, Wallet, Clapperboard } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  { Icon: MessageCircle, title: "كلمنا وابعت اللوجو والبريف", text: "ابعتلنا على واتساب أو فيسبوك أو إنستجرام، أو املا فورم «اعمل إعلانك»، ومعاه لوجو البراند بجودة كويسة وفكرة سريعة عن البراند والجمهور اللي عايز توصله." },
  { Icon: Palette, title: "الأولويات والألوان", text: "قولنا أهم نقط الإعلان، ألوانك، وأي تفاصيل أو أمثلة عاجباك." },
  { Icon: Wallet, title: "50% مقدم", text: "بتدفع نص المبلغ قبل ما نبدأ الإنتاج، وساعتها نبدأ نخربش على طول." },
  { Icon: Clapperboard, title: "50% بعد ما الفيديو يخلص", text: "الفيديو بيخلص، تشوفه، وبعدها تدفع الـ50% الباقية وتستلم النسخة النهائية." },
];

export const ProcessSteps = () => (
  <ol className="relative grid gap-5 md:grid-cols-2 lg:grid-cols-4" data-testid="process-steps">
    <svg className="pointer-events-none absolute inset-x-0 top-10 hidden h-6 w-full lg:block" viewBox="0 0 1000 24" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 12 Q 50 0 100 12 T 200 12 T 300 12 T 400 12 T 500 12 T 600 12 T 700 12 T 800 12 T 900 12 T 1000 12" stroke="#7D2CC6" strokeWidth="3" strokeDasharray="8 10" fill="none" />
    </svg>
    {STEPS.map(({ Icon, title, text }, i) => (
      <Reveal key={title} delay={i * 0.08} className="relative">
        <li className={`group h-full rounded-3xl border border-purple-500/25 bg-[var(--km-card)] p-5 transition-[transform,border-color] duration-300 hover:-translate-y-2 hover:border-[var(--km-pink)] ${i % 2 ? "lg:mt-10" : ""}`} data-testid={`process-step-${i + 1}`}>
          <div className="mb-4 flex items-center justify-between">
            <span className="grid h-14 w-14 place-items-center rounded-2xl bg-[var(--km-purple)] text-white transition-transform duration-300 group-hover:rotate-12">
              <Icon className="h-7 w-7" />
            </span>
            <span className="font-display text-5xl text-[var(--km-purple)]/60">{i + 1}</span>
          </div>
          <h3 className="font-head mb-2 text-xl font-bold text-white">{title}</h3>
          <p className="text-sm leading-relaxed text-purple-200/85">{text}</p>
        </li>
      </Reveal>
    ))}
  </ol>
);

export const PaymentCard = () => (
  <Reveal>
    <div className="relative mt-10 grid overflow-hidden rounded-[2rem] border-2 border-dashed border-[var(--km-cyan)]/60 bg-black/40 md:grid-cols-2" data-testid="payment-card">
      {[
        { pct: "50%", label: "قبل الإنتاج", text: "مقدم بنبدأ بيه شغل الإعلان من سكريبت وتصميم وتحريك.", color: "var(--km-pink)" },
        { pct: "50%", label: "بعد ما الفيديو يخلص", text: "الباقي بتدفعه لما الفيديو يكمل، وبعدها تستلم النسخة النهائية.", color: "var(--km-cyan)" },
      ].map((p, i) => (
        <div key={i} className={`p-8 ${i === 0 ? "border-b-2 border-dashed border-[var(--km-cyan)]/40 md:border-b-0 md:border-l-2" : ""}`}>
          <p className="font-display text-7xl leading-none" style={{ color: p.color }}>{p.pct}</p>
          <p className="font-head mt-2 text-2xl font-bold text-white">{p.label}</p>
          <p className="mt-2 text-purple-200/85">{p.text}</p>
        </div>
      ))}
    </div>
  </Reveal>
);
